<template>
  <v-app-bar  app dense >
        <v-toolbar-title class="font-weight-light primary--text display-1">IFU Generator</v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- Authentication State = initial: user not authenticated, sign in info and reset Password -->
        <v-text-field 
            class="custom-placeholder-color mr-3 mt-7" 
            color="primary" height="20"
            v-if="authentication_state === 'initial'" 
            v-model="email" 
            label="Email">
            </v-text-field>
        <v-text-field 
            class="mt-7" 
            height="20" 
            v-if="authentication_state === 'initial'" 
            v-model="password"
            label="Password" 
            type="password">
            </v-text-field>
        <v-btn text 
            class="font-weight-light primary--text" 
            @click="Authenticate" 
            v-if="authentication_state === 'initial'">
                <span>Sign in</span>
                <v-icon right>mdi-login-variant</v-icon>
        </v-btn>
        <!-- <a class="font-weight-light primary--text"
            v-if="authentication_state === 'initial'" 
            href="#" @click="ResetPassword">Forgot Password?</a> -->
        <!-- Authentication State = signed_in: user authenticated, only sign out -->
        <p class="font-weight-light primary--text mt-4"
            v-if="authentication_state === 'signed_in'">
            Wecome {{ email }}!
            </p>
        <v-btn text 
            class="font-weight-light primary--text" 
            @click="Logout" 
            v-if="authentication_state === 'signed_in'">
                <span>Sign Out</span>
                <v-icon right>mdi-logout-variant</v-icon>
        </v-btn>
        <!-- Authentication State = new_password: initial user sign in with password change, enter new password -->
        <v-dialog 
            v-model="new_pass_dialog"
            persistent
            max-width="600px"
            center>
            <v-card
                max-width="550px">
                <p class="font-weight-regular primary--text text-center mt-7 mr-3">
                    Welcome! Enter a new password to sign in.
                </p>
                 <p class="font-weight-light primary--text text-center mt-7 mr-3">(Remember, your password needs to be at least 8 characters, 
                        consist of upper and lowercase letters and at least one number.)</p>
                    <hr>
                <v-form
                    ref="change_password">
                    <p class="font-weight-light primary--text mt-3 ml-7">
                        Enter New Password:
                        </p>
                    <v-text-field 
                        class="mt-2 ml-7" 
                        v-model="newPassword"
                        label="New Password" 
                        :rules="passwordRules"
                        type="password">
                        </v-text-field>
                    <p class="font-weight-light primary--text mt-3 ml-7">
                        Confirm New Password:
                        </p>
                    <v-text-field 
                        class="mt-2 ml-7" 
                        label="Confirm New Password" 
                        :rules="confirmPasswordRules"
                        type="password">
                        </v-text-field>
                    <v-row align="center" justify="start">    
                        <v-checkbox
                            class="font-weight-light ml-10" 
                            color="primary" 
                            v-model="checkbox"
                            :rules="[v => !!v || 'You must agree to continue!']"
                            label="Agree to Terms of Use"
                            required
                            ></v-checkbox>
                        <v-btn 
                            class="ml-7"
                            text icon color="primary"
                            @click="terms_dialog = true">
                            <v-icon dark>mdi-eye-outline</v-icon>
                        </v-btn>
                    </v-row>
                    <v-btn 
                        class="font-weight-light primary--text ml-7"
                        @click="NewPassSubmit" >
                        Submit
                    </v-btn>
                    <v-btn 
                        class="font-weight-light primary--text ml-7"
                        @click="CancelNewPassSubmit" >
                        Cancel
                    </v-btn>
                </v-form>
            </v-card>
        </v-dialog>
        <!-- Terms of Use dialog -->
        <v-dialog  
            v-model="terms_dialog"
            persistent
            max-width="300px">
            <v-card>
                <p class="font-weight-regular primary--text">Terms of Use:</p>
                <p class="font-weight-light">Synoptyx makes no warranty on the use of the IFU Generator tool. 
                    All output from the tool must be verified according to approved document control procedures.</p>
                <button class="font-weight-light primary--text"  @click="terms_dialog = false">Close</button>
            </v-card>
        </v-dialog>
        <!-- Authentication State = reset_password: user to change password, enter new password -->
    </v-app-bar>
</template>

<script>
import Amplify, { Auth } from 'aws-amplify';
import awsconfig from '../../aws-exports';
Amplify.configure(awsconfig);
export default {

data() {
        return {
            newUser: {},
            email: '',
            emailRules: [ v => !!v || 'E-mail is required',
                v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                ],
            password: '',
            passwordRules: [
                v => !!v || 'Password is Required',
                v => v.length > 6 || 'Password length must be greater then 6 characters',
                v => /[a-z]+/.test(v) || 'At least one lowercase letter is required',
                v => /[A-Z]+/.test(v) || 'At least one Uppercase letter is required',
                v => /[0-9]+/.test(v) || 'At least one number is required'
            ],
            newPassword: '',
            confirmPasswordRules: [
                v => !!v || 'You must confirm your new password',
                v => v === this.newPassword || 'Confirm password does not match'
            ],
            authentication_state: 'initial',
            new_pass_dialog: false,
            checkbox: false,
            terms_dialog: false
        }
    },

methods: {
        Authenticate() {
            Auth.signIn(this.email, this.password)
                .then(user => {
                    if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
                        // // eslint-disable-next-line no-console
                        // console.log(user);
                        this.newUser = user;
                        this.new_pass_dialog = true;
                    } else {
                        this.authentication_state = 'signed_in';
                        this.$router.push('/IFU');
                    }
                }
                // eslint-disable-next-line
                ).catch(err => alert('Email or the Password is incorrect! Try again.'))
        },  
        Logout() {
            Auth.signOut()
                .then(data => {
                    // eslint-disable-next-line no-console
                    console.log(data);
                    this.authentication_state = 'initial';
                    this.email = ''
                    this.password = ''
                    this.$router.push('/');
                })
                // eslint-disable-next-line no-console
                .catch(err => console.log(err))
       },
        ResetPassword() {
            this.authentication_state = 'initial';
            this.$router.push('/');
        },
        CancelNewPassSubmit() {
            this.$refs.change_password.reset()
            this.email = ''
            this.password = ''
            this.new_pass_dialog = false
        },
        NewPassSubmit() {
            if(this.$refs.change_password.validate()) {
                 Auth.completeNewPassword(this.newUser, this.newPassword)
                 // eslint-disable-next-line
                .then(user => {
                   this.authentication_state = 'signed_in';
                    this.$router.push('/IFU');
                }).catch(e => {
                    // eslint-disable-next-line no-console
                    console.log(e);
                    alert(e)
                    this.$refs.change_password.reset()
                    this.email = ''
                    this.password = ''
                    this.new_pass_dialog = false;
                })
                this.new_pass_dialog = false;
            }
        }
    },
}
</script>

<style>

</style>